import React from 'react'
import { features } from '../constant/Data'




const Features = () => {
    return (
        <section className="py-20 bg-white" id='features'>
            <div className="max-w-7xl mx-auto px-4">
                <h2 className="text-3xl font-bold text-center mb-4 text-navy-900">
                    Experience Fast, Powerful Lung Relief                </h2>
                <p className="text-gray-600 text-center mb-12">
                    Discover the Proven Benefits That Make Lung Renew™ the Ultimate Solution for Healthy Breathing                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-12 gap-x-8">
                    {features.map((feature, index) => (
                        <div class=" md:col-span-1 col-span-3 group rounded-2xl  ">

                            <div
                                key={index}
                                class="rounded-2xl relative w-full h-full p-6 flex text-center flex-col items-center bg-[#D0DFF2] hover:bg-[#092A53] gap-2 transition-colors">
                                <div class="p-3 absolute  border -top-8 bg-white group-hover:bg-[#D0DFF2] rounded-full  ">
                                    <img src={feature.icon} alt='img' className='w-10 h-10 ' />
                                </div>
                                <div class="pt-6">
                                    <h3 class="font-semibold text-lg  group-hover:text-white text-[#212529]">{feature.title}
                                    </h3>
                                    <p class="text-gray-600 group-hover:text-white text-sm">{feature.description}</p>
                                </div>

                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Features
